import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import { scrollToElement } from '@sparefoot/react-core/utils/scrolling';

import './alert.scss';

export class Alert extends PureComponent {
	componentDidMount() {
		const { scrollIntoView } = this.props;
		if (this.instance && scrollIntoView) {
			scrollToElement(this.instance, { offset: -16 });
		}
	}

	getRef = (instance) => {
		this.instance = instance;
	};

	render() {
		const { children, type, className } = this.props;
		return (
			<div
				className={classnames('ss-alert', type, className)}
				ref={this.getRef}
			>
				{children}
			</div>
		);
	}
}
Alert.propTypes = {
	children: PropTypes.node,
	type: PropTypes.oneOf(['warning', 'success']),
	scrollIntoView: PropTypes.bool,
	className: PropTypes.string,
};

export default Alert;
